import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { NumericFormat } from "react-number-format";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
export var productInvoiceList = [
    {
        key: "edit",
        render: function(param) {
            var item = param.item, setProductRow = param.setProductRow, addProductRow = param.addProductRow, productSearch = param.productSearch, handleOnSelect = param.handleOnSelect, handleOnClear = param.handleOnClear, handleOnFocus = param.handleOnFocus, handleOnSearch = param.handleOnSearch, formatResult = param.formatResult, rowCount = param.rowCount, index = param.index;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: !item.edit ? /*#__PURE__*/ _jsx("button", {
                            className: "btn btn-shadow fs-14",
                            style: {
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                minHeight: "35px"
                            },
                            onClick: function(e) {
                                setProductRow(function(prev) {
                                    return prev.map(function(el) {
                                        if (el.rowID === item.rowID) {
                                            return _object_spread_props(_object_spread({}, el), {
                                                edit: true
                                            });
                                        }
                                        return el;
                                    });
                                });
                                if (rowCount - index <= 2) {
                                    addProductRow(2);
                                }
                            },
                            disabled: item.soItemID,
                            children: item.productCode
                        }) : /*#__PURE__*/ _jsx(ReactSearchAutocomplete, {
                            items: productSearch,
                            placeholder: "",
                            onSelect: function(items) {
                                return handleOnSelect(items, item.rowID);
                            },
                            onClear: handleOnClear,
                            onFocus: handleOnFocus,
                            onSearch: handleOnSearch,
                            autoFocus: true,
                            formatResult: formatResult,
                            fuseOptions: {
                                keys: [
                                    "barcode",
                                    "dimProduct.name_th"
                                ]
                            },
                            resultStringKeyName: "barcode",
                            inputSearchString: item.barcode,
                            styling: {
                                height: "34px",
                                borderRadius: "10px",
                                border: 0,
                                fontSize: "14px",
                                boxShadow: "none",
                                zIndex: 1
                            },
                            showIcon: false,
                            showClear: false,
                            className: "scrollSearchAutocomplete",
                            disabled: true
                        })
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "productQty",
        render: function(param) {
            var values = param.values, item = param.item, setProductRow = param.setProductRow, filterDisplay = param.filterDisplay;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        className: "".concat(values.fact_new_do_id ? "!bg-[#E5ECFB]" : ""),
                        children: item.productID != "" && !values.fact_new_do_id ? /*#__PURE__*/ _jsx("input", {
                            type: "number",
                            className: "form-control formv text-center border-0 me-2",
                            value: item.productQty,
                            onFocus: function(e) {
                                return e.target.select();
                            },
                            onWheel: function(e) {
                                return e.target.blur();
                            },
                            onChange: function(e) {
                                setProductRow(function(prev) {
                                    return prev.map(function(el) {
                                        if (el.rowID === item.rowID) {
                                            return _object_spread_props(_object_spread({}, el), {
                                                productQty: e.target.value
                                            });
                                        }
                                        return el;
                                    });
                                });
                            },
                            disabled: values.fact_new_do_id
                        }) : /*#__PURE__*/ _jsx(NumericFormat, {
                            className: "bg-[#E5ECFB] text-[#565DFF]",
                            displayType: "text",
                            thousandSeparator: ",",
                            decimalScale: 0,
                            fixedDecimalScale: true,
                            value: item.productQty
                        })
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body ".concat(values.fact_new_do_id ? "!bg-[#E5ECFB]" : "")
                    })
                ]
            });
        }
    },
    {
        key: "productsStock",
        remove: true,
        render: function() {
            return null;
        }
    },
    {
        key: "warehouseID",
        remove: true,
        render: function() {
            return null;
        }
    }
];
